import { render, staticRenderFns } from "./QuitarPendiente.vue?vue&type=template&id=235c7fd0&scoped=true"
import script from "./QuitarPendiente.vue?vue&type=script&lang=js"
export * from "./QuitarPendiente.vue?vue&type=script&lang=js"
import style0 from "./QuitarPendiente.vue?vue&type=style&index=0&id=235c7fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c7fd0",
  null
  
)

export default component.exports